import { render, staticRenderFns } from "./echarts.vue?vue&type=template&id=2b34d486&"
import script from "./echarts.vue?vue&type=script&lang=js&"
export * from "./echarts.vue?vue&type=script&lang=js&"
import style0 from "./echarts.vue?vue&type=style&index=0&id=2b34d486&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports